import { Outlet } from 'react-router-dom';
import { CrmPageNotificationsProvider } from '../contexts/CrmPageNotificationsContext';
import { PortalProvider } from '../contexts/PortalContext';
import type { PortalKind } from '../lib/portal';
import { RequireAuth } from './RequireAuth';
import { RequirePortalChoice } from './RequirePortalChoice';
import { CrmDataProvider } from '../contexts/CrmDataContext';
import { AppShell } from './layout/AppShell';

export function PortalApp({ kind }: { kind: PortalKind }) {
  return (
    <PortalProvider kind={kind}>
      <RequireAuth>
        <RequirePortalChoice>
          <CrmDataProvider>
            <CrmPageNotificationsProvider>
              <AppShell />
            </CrmPageNotificationsProvider>
          </CrmDataProvider>
        </RequirePortalChoice>
      </RequireAuth>
    </PortalProvider>
  );
}

export function PortalAppOutlet({ kind }: { kind: PortalKind }) {
  return (
    <PortalProvider kind={kind}>
      <Outlet />
    </PortalProvider>
  );
}
